import { APPLICATION_ROUTES } from '@philips-emr/hpms-stipulator-commons';
import TokenConstants from '@philips-emr/hpms-stipulator-commons/lib/constants/token-constants';
import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import { ThemeTonalRange } from '@philips-emr/tws-constants';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { AuthenticationService, ThemeService } from '@philips-emr/tws-core/lib/services';
import { applicationContext } from '@philips-emr/tws-foundation/lib/context';

import BaseController from './BaseController';

@Controller({ fragment: 'redirect' })
export default class RedirectControler extends BaseController {

  @OnMount({ target: 'panel-redirect' })
  onMount(): void {
    ThemeService.setContentTonalRange(ThemeTonalRange.ULTRA_LIGHT);
    applicationContext.clearNavigationStack();

    const token = AuthenticationService.getJWTToken();
    const nrSeqGrupoContratoWeb = token ? token.claims[TokenConstants.NR_SEQ_GRUPO_CONTRATO_WEB] as string : '';

    const { nrSeqContrato } = StipulatorContext.getCurrentContract();

    this.historyService.push(APPLICATION_ROUTES.DASHBOARD, { nrSeqGrupoContratoWeb, nrSeqContrato });
  }
}
